/*
 * Sold / display-only product pages: removes purchase controls that theme or
 * variant scripts may re-inject next to a [data-aged-sold] marker.
 * Loaded only from the sold branch of snippets/buy-buttons.liquid.
 */
(function () {
  if (window.agedSoldInit) return;
  window.agedSoldInit = true;

  const LEFTOVER_SELECTORS = [
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
    '.product-form__quantity',
    '.product-form__submit',
    '[id^="ProductSubmitButton-"]',
  ].join(',');

  function clean() {
    document.querySelectorAll('[data-aged-sold]').forEach((marker) => {
      const scope = marker.closest('product-info') || marker.closest('.product__info-container') || marker.parentElement;
      if (!scope) return;
      scope.querySelectorAll(LEFTOVER_SELECTORS).forEach((el) => el.remove());
    });
  }

  let scheduled = false;
  function scheduleClean() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      clean();
    });
  }

  clean();
  new MutationObserver(scheduleClean).observe(document.body, { childList: true, subtree: true });
})();
